var map = {
	"./BioMatrix.vue": 7125,
	"./CodexFieldWallet.vue": 40653,
	"./DailyInvite.vue": 72047,
	"./achievements.vue": 97591,
	"./activity.vue": 42430,
	"./airdrop.vue": 23686,
	"./airdropFirst.vue": 80936,
	"./airdropInviter.vue": 27563,
	"./airdropReward.vue": 21711,
	"./airdropSecond.vue": 16733,
	"./appcenter.vue": 77825,
	"./avatar.vue": 80735,
	"./bioMatrixScan.vue": 1171,
	"./bioMatrixScanDetail.vue": 86880,
	"./bioMatrixScanInvite.vue": 1706,
	"./bitgetWallet.vue": 52529,
	"./bitgetWalletAirdrop.vue": 69415,
	"./blind.vue": 80585,
	"./boost.vue": 38687,
	"./code.vue": 84016,
	"./depositDetail.vue": 6919,
	"./earn.vue": 6131,
	"./forturn.vue": 64615,
	"./frens.vue": 2673,
	"./game/2048.vue": 24698,
	"./game/aaGame.vue": 65630,
	"./game/bubbleShooter.vue": 97350,
	"./game/circleMerge.vue": 11839,
	"./game/fruitRush.vue": 86990,
	"./game/index.vue": 96092,
	"./game/rank.vue": 71322,
	"./game/sheep.vue": 97704,
	"./game/tapUp.vue": 57465,
	"./game/tileConnect.vue": 66056,
	"./game/zenBlocks.vue": 34534,
	"./giftInventory.vue": 84028,
	"./giftLucky.vue": 62792,
	"./gifts.vue": 51144,
	"./index.vue": 65581,
	"./join.vue": 95344,
	"./lottery.vue": 95319,
	"./lotteryDetail.vue": 15395,
	"./lucky.vue": 38329,
	"./luckyBox.vue": 8881,
	"./luckyBoxNew.vue": 6679,
	"./mine.vue": 50837,
	"./mpay.vue": 27547,
	"./nftInfo.vue": 42467,
	"./nftInvite.vue": 59038,
	"./nftLucky.vue": 28440,
	"./nftdetail.vue": 62361,
	"./nfts.vue": 55663,
	"./okxWallet.vue": 13320,
	"./pph.vue": 33297,
	"./rank.vue": 75592,
	"./sign.vue": 75507,
	"./slotMachine.vue": 12994,
	"./solojack.vue": 69845,
	"./squad.vue": 93154,
	"./taskDetail.vue": 28780,
	"./usdEvent.vue": 83179,
	"./usdLucky.vue": 8818,
	"./wallet.vue": 4605,
	"./walletDetail.vue": 90442,
	"./withdraw.vue": 50347,
	"./youtube.vue": 33452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;